import { AppState } from '../../../store/store'
export const selectTableFilter = (state: AppState) => state.tableFilterReducer.data
